module.exports = __webpack_public_path__ + "img/rtf.ac9dadd2.png";